import { mainService, homeService } from '@/utils/request'

// 获取模块分类
export function getTempList (data) {
  return mainService({
    url: 'app/home/get_temp_class',
    method: 'post',
    data: data
  })
}

// 获取模块分类信息
export function getTempClassInfo (data) {
  return mainService({
    url: 'app/home/get_temp_class_info',
    method: 'post',
    data: data
  })
}

// 获取图库栏目
export function getImageColumnList () {
  return mainService({
    url: 'app/home/get_pic_column_list',
    method: 'post',
    data: {
      user_id: ''
    }
  })
}

// 获取轮播图列表
export function getBannerList () {
  return homeService({
    url: 'web/listBanner',
    method: 'post',
    headers: {
      'Pointpath': 'guituyun'
    }
  })
}

// 获取精选图片列表
export function getSpecialPicture () {
  return homeService({
    url: 'web/listSpecialPicture',
    method: 'post',
    headers: {
      'Pointpath': 'guituyun'
    }
  })
}

// 获取活动列表
export function getActivityList () {
  return homeService({
    url: 'web/listActivity',
    method: 'post',
    headers: {
      'Pointpath': 'guituyun'
    }
  })
}

// 获取活动详情
export function getActivityDetail (data) {
  return homeService({
    url: 'web/getActivityDetail',
    method: 'post',
    data: data,
    headers: {
      'Pointpath': 'guituyun'
    }
  })
}

// 获取活动轮播图列表
export function getActivityBannerList () {
  return homeService({
    url: 'web/list_chart',
    method: 'post',
    headers: {
      'Pointpath': 'guituyun'
    }
  })
}

// 获取关注列表（type = 1 摄影师， type = 2 机构）
export function getHomeAttentionList (data) {
  return mainService({
    url: 'app/home/get_attention',
    method: 'post',
    data: data,
    headers: {
      'Pointpath': 'guituyun'
    }
  })
}
// 活动提交作品
export function submitActiveProduct (data) {
  return homeService({
    url: 'web/submit',
    method: 'post',
    data: data,
    headers: {
      'Pointpath': 'guituyun'
    }
  })
}

// 获取活动可选图片列表
export function getActiveImgChoiceList (data) {
  return homeService({
    url: 'web/res_list',
    method: 'post',
    data: data,
    headers: {
      'Pointpath': 'guituyun'
    }
  })
}

// 获取活动全部作品
export function getActiveProductAllList (data) {
  return homeService({
    url: 'web/activity_list',
    method: 'post',
    data: data,
    headers: {
      'Pointpath': 'guituyun'
    }
  })
}

// 获取活动个人作品
export function getActiveProductPersonList (data) {
  return homeService({
    url: 'web/works_list',
    method: 'post',
    data: data,
    headers: {
      'Pointpath': 'guituyun'
    }
  })
}
// 退出活动
export function outactiveproduct (data) {
  return homeService({
    url: 'admin/activity/works/repeal_works',
    method: 'post',
    data: data,
    headers: {
      'Pointpath': 'guituyun'
    }
  })
}

// 我要报名
export function signupActivity (data) {
  return homeService({
    url: 'web/activity/signUp',
    method: 'post',
    data: data,
    headers: {
      'Pointpath': 'guituyun'
    }
  })
}

// 获取我的报名
export function geMysignuoInfo (data) {
  return homeService({
    url: 'web/activity/mySignUp' + data,
    method: 'get',
    headers: {
      'Pointpath': 'guituyun'
    }
  })
}
